<template>
  <px-custom-dialog transition="fadet"
                    width="550"
                    v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Telefones
    </template>
    <template>
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            dense
            outlined
            hide-details
            type="phone"
            label="Telefone"
            v-mask="mask"
            maxlength="20"
            class="required rounded-tag-small"
            v-model="whatsapp"
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            dense
            outlined
            hide-details
            label="Nome contato"
            maxlength="100"
            class="rounded-tag-small"
            v-model="nome"
          />
          <div class="mt-1 text-right">
            <v-btn small
              class="normal-btn-text rounded-tag-small elevation-0"
              color="primary"
              :disabled="$v.$invalid"
              @click="adicionarWhatsapp">
              <v-icon small>mdi-plus</v-icon>
              {{ editMode ? 'Atualizar' : 'Adicionar' }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-card outlined class="rounded-card">
            <v-list>
              <v-list-item>
                <v-list-item-title class="text--primary">
                  Telefones
                </v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item v-for="(item, i) in fornecedor.contatosWhatsapp" :key="i">
                <v-list-item-icon >
                  <v-icon :color="iconColor(item)">
                    {{ icon(item) }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ formatWhats(item.telefone) | naoInformado}}
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="item.nome">
                    {{item.nome}}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="item.id">
                  <v-btn icon small @click="edit(item)">
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn icon small @click="remove(item)">
                    <v-icon small>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item v-if="!fornecedor.contatosWhatsapp.length">
                <v-list-item-title>Nenhum telefone informado</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             :loading="loading"
             @click="save">
        Salvar
      </v-btn>
      <v-btn text class="normal-btn-text" @click="close">
        Cancelar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import Vue from 'vue';
import { required } from 'vuelidate/lib/validators';
import { onlyNumbers } from '@/utils/regex-utils';
import GestaoFornecedorService from '../../gestao-fornecedor-service';

export default {
  props: {
    currentFornecedor: Object,
    isNacional: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: null,
      loading: false,
      whatsapp: null,
      nome: null,
      id: null,
      fornecedor: {
        contatosWhatsapp: [],
      },
    };
  },
  computed: {
    iconColor() {
      return (contato) => {
        if (!contato.whatsappValido) {
          return '';
        }
        return contato.ativo ? 'green' : 'red';
      };
    },
    icon() {
      return contato => (contato.whatsappValido ? 'mdi-whatsapp' : 'mdi-phone');
    },
    editMode() {
      return !!this.id;
    },
    mask() {
      return this.isNacional ? ['(##) ####-####', '(##) #####-####'] : ['XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'];
    },
    formatWhats() {
      return whatsapp => (this.isNacional ? Vue.filter('phone')(whatsapp) : whatsapp);
    },
  },
  methods: {
    close() {
      this.whatsapp = null;
      this.nome = null;
      this.dialog = false;
    },
    remove(item) {
      this.fornecedor.contatosWhatsapp = this.fornecedor.contatosWhatsapp
        .filter(whats => whats !== item);
    },
    getWhatsapps() {
      GestaoFornecedorService.get(this.currentFornecedor.id)
        .then((response) => {
          const fornecedor = response.data;
          this.fornecedor.contatosWhatsapp = fornecedor.contatosWhatsapp || [];
        });
    },
    adicionarWhatsapp() {
      const telefone = onlyNumbers(this.whatsapp);
      const contato = {
        telefone,
        nome: this.nome,
      };
      if (this.id) {
        contato.id = this.id;
      }

      const existing = this.fornecedor.contatosWhatsapp.find(
        c => c.id === this.id && this.id !== null,
      );

      if (existing) {
        Object.assign(existing, contato);
      } else if (!(this.fornecedor.contatosWhatsapp.some(c => c.telefone === telefone))) {
        this.fornecedor.contatosWhatsapp.push(contato);
      } else {
        this.$toast('Whatsapp já incluso a lista', { color: 'error' });
      }
      this.whatsapp = null;
      this.nome = null;
      this.id = null;
    },
    edit(contato) {
      this.whatsapp = contato.telefone;
      this.nome = contato.nome;
      this.id = contato.id;
    },
    initialState() {
      this.getWhatsapps();
    },
    buildPayload() {
      const fornecedor = { ...this.fornecedor };
      return fornecedor;
    },
    save() {
      this.loading = true;
      GestaoFornecedorService.updateWhatsapp(this.currentFornecedor.id, this.buildPayload())
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('Telefones Adicionados', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.initialState();
    },
  },
  validations: {
    whatsapp: {
      required,
      customMinLength(value) {
        if (!value) return true;
        const len = value.replace(/\D/g, '').length;
        return this.isNacional ? len >= 10 : len >= 11;
      },
    },
  },
};
</script>
